import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=67fc6a44&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fc6a44"]])

export default __exports__